import React, { useContext, useEffect } from 'react';

import { ContextNotificacoes } from '../../../services/notificacoes';

import { ReactComponent as Business } from '../../../assets/novosicones/notificacoes/highlight.svg';

import SatisfactionSurvey from '../../SatisfactionSurvey';

import { ContextSolicitacoes } from '../../../services/solicitacoes';
import { getSurvey } from '../../../Utils/tiposPesquisaSatisfacao';

const SurveyResearch = ({ tema, setNotificationsModal }) => {
  const { setSurveyModal, setOpenSurveyModal, openSurveyModal } =
    useContext(ContextNotificacoes);

  const { getTipoSolicitacoes, tiposSolicitacoes } =
    useContext(ContextSolicitacoes);

  useEffect(() => {
    const getTiposSolicitacao = async () => {
      await getTipoSolicitacoes();
    };

    if (!tiposSolicitacoes?.length > 0) {
      getTiposSolicitacao();
    }
  }, []);

  const NOTIFICATIONSSURVEYRESEARCH = JSON.parse(
    sessionStorage.getItem('notificationsPesquisa')
  );

  let checkIfNewDestaque = [];

  if (NOTIFICATIONSSURVEYRESEARCH?.length > 0)
    checkIfNewDestaque = NOTIFICATIONSSURVEYRESEARCH.filter((item) => {
      return !item.Visualizado;
    });

  if (checkIfNewDestaque.length == 0) return null;

  const notificationIsEnding = (date) => {
    const todayTime = new Date().getTime();
    const endTime = new Date(date).getTime();
    const limitMillis = 5 * 24 * 60 * 60 * 1000;

    return todayTime - endTime > limitMillis;
  };

  const handleCloseModals = () => {
    setSurveyModal(null);
    setOpenSurveyModal(false);
  };

  const handleOpenModal = (survey) => {
    setSurveyModal(survey);
    setOpenSurveyModal(true);
  };

  return (
    <div className='notifications__item' style={{ marginTop: '32px' }}>
      <span
        className='notifications__item__title'
        style={{ color: tema.primaryColor }}
      >
        Pesquisa de satisfação:
      </span>
      {NOTIFICATIONSSURVEYRESEARCH?.length > 0 &&
        NOTIFICATIONSSURVEYRESEARCH.map((survey) => {
          return (
            <div className='centralized-space-between' key={survey.Id}>
              <div className='centralized'>
                <span
                  style={{ width: '24px', height: '24px', display: 'block' }}
                >
                  <Business style={{ fill: tema.primaryColor }} />
                </span>
                <p
                  className='notifications__item__description'
                  style={{ color: '#454545' }}
                >
                  {notificationIsEnding(survey.DataConclusao ?? survey.Criado)
                    ? getSurvey(survey, tiposSolicitacoes)
                        ?.textoNotificacaoPrazoAcabando
                    : getSurvey(survey, tiposSolicitacoes)?.textoNotificacao}
                </p>
              </div>
              <a
                onClick={() => handleOpenModal(survey)}
                style={{ color: tema.primaryColor, cursor: 'pointer' }}
              >
                RESPONDER
              </a>
            </div>
          );
        })}

      {openSurveyModal && (
        <SatisfactionSurvey
          close={handleCloseModals}
          setNotificationsModal={setNotificationsModal}
        />
      )}
    </div>
  );
};

export default SurveyResearch;
